import { type Meta } from '../types/docs';
import { UPLOAD_ANALYTICS_COMMON_META_PARAMS } from './uploadAnalyticsMetaParams';

const META: Meta = {
  description: 'A multipart upload part failed during transfer',
  name: 'upload_part_error',
  params: [
    ...UPLOAD_ANALYTICS_COMMON_META_PARAMS,
    {
      description: 'One-indexed multipart part number',
      name: 'part_number',
      required: true,
      type: 'number',
    },
    {
      description: 'Part size in bytes',
      name: 'part_size_bytes',
      required: false,
      type: 'number',
    },
    {
      description: 'Number of retries already attempted before this failure',
      name: 'retry_count',
      required: false,
      type: 'number',
    },
    {
      description: 'Maximum retry count configured for multipart parts',
      name: 'max_retry_count',
      required: false,
      type: 'number',
    },
    {
      description: 'Failure message',
      name: 'error_message',
      required: true,
      type: 'string',
    },
    {
      description: 'JavaScript error name',
      name: 'error_name',
      required: false,
      type: 'string',
    },
    {
      description: 'HTTP status code for upload status errors',
      name: 'error_status_code',
      required: false,
      type: 'number',
    },
    {
      description: 'Whether the transfer error is retryable',
      name: 'is_retryable',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Which presigned URL type the part transfer used',
      name: 'upload_url_type',
      required: true,
      type: 'enum',
      values: ['primary', 'fallback'],
    },
  ],
};

export default META;
